import { ExternalLink, ShieldAlert } from "lucide-react";

const isFramed = () => {
  try { return window.self !== window.top; } catch { return true; }
};

// Anti-clickjacking: sensitive pages refuse to render inside another site's frame.
export function FrameGuard({ children }) {
  if (!isFramed()) return children;
  return (
    <main className="min-h-screen flex items-center justify-center bg-brand-cream px-6" data-testid="frame-guard">
      <div className="max-w-md text-center bg-white border border-brand-line rounded-3xl p-8">
        <ShieldAlert aria-hidden="true" className="w-8 h-8 text-brand-rose mx-auto" />
        <h1 className="mt-4 font-serif text-2xl text-brand-charcoal">Open this page directly</h1>
        <p className="mt-2 text-sm text-brand-muted">
          For your security, this page can't be shown inside another website.
        </p>
        <a href={window.location.href} target="_blank" rel="noopener noreferrer" data-testid="frame-guard-open"
          className="mt-6 inline-flex items-center gap-2 bg-brand-teal text-white rounded-full px-5 py-2.5 text-sm font-medium hover:bg-brand-tealDark">
          Open in a new tab <ExternalLink aria-hidden="true" className="w-4 h-4" />
        </a>
      </div>
    </main>
  );
}
